import { ReactComponent as DownArrow } from "../../../assets/icons/downArrow.svg";
import { ReactComponent as Select } from "../../../assets/icons/select.svg";
import { ReactComponent as FileSearch } from "../../../assets/icons/fileSearch.svg";
import { ReactComponent as LeftArrow } from "../../../assets/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "../../../assets/icons/rightArrow.svg";
import { ReactComponent as CloseBlackIcon } from "../../../assets/icons/closeIcon.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plusIcon.svg";
import { ReactComponent as UploadImage } from "../../../assets/icons/uploadImage.svg";
import { ReactComponent as UploadOnImage } from "../../../assets/icons/uploadOnImage.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/closeWhiteIcon.svg";

import TableName from "../../../components/common/tableName";
import Input from "../../../components/common/input";
import Button from "../../../../common/components/button";
import SelectBox from "../../../components/common/selectBox";
import Toggle from "../../../components/common/toggle";
import DayPickerInput from "../../../components/common/DayPickerInput";
import React, { useEffect, useState } from "react";
import { useGetOrderCustomer } from "../../../../common/hooks/console/transaction/useGetOrderCustomer";
import SearchAddress from "../../../components/common/searchAddress";
import { api_uri } from "../../../../common/hooks/utils/enum";
import { useGetOrderProduct } from "../../../../common/hooks/console/transaction/useGetOrderProduct";
import { useGetCommonSender } from "../../../../common/hooks/common/useGetCommonSender";
import { useGetCommonWords } from "../../../../common/hooks/common/useGetCommonWords";
import { useGetCommonMemo } from "../../../../common/hooks/common/useGetCommonMemo";
import { useGetCommonEvent } from "../../../../common/hooks/common/useGetCommonEvent";
import { usePostOrder } from "../../../../common/hooks/console/transaction/usePostOrder";
import { useSystemPopStore } from "../../../store/useSystemPopStore";
import { useAuthStore } from "../../../store/useAuthStore";
import { useGetOrderManager } from "../../../../common/hooks/console/transaction/useGetOrderManager";
import CheckBox from "../../../components/common/checkBox";
import { useGetCustomerMemo } from "../../../../common/hooks/console/management/customer/useGetCustomerMemo";
import NewOrderSearchAddress from "console/components/common/newOrderSearchAddress";

const hoursOptions = [
    { value: "오전중", label: "오전중" },
    { value: "오후중", label: "오후중" },
    { value: "당일배송", label: "당일배송" },
    { value: "08시", label: "오전 08시" },
    { value: "09시", label: "오전 09시" },
    { value: "10시", label: "오전 10시" },
    { value: "11시", label: "오전 11시" },
    { value: "12시", label: "오후 12시" },
    { value: "13시", label: "오후 01시" },
    { value: "14시", label: "오후 02시" },
    { value: "15시", label: "오후 03시" },
    { value: "16시", label: "오후 04시" },
    { value: "17시", label: "오후 05시" },
    { value: "18시", label: "오후 06시" },
    { value: "19시", label: "오후 07시" },
    { value: "20시", label: "오후 08시" },
];

const minutesOptions = [
    { value: "00", label: "00분" },
    { value: "10", label: "10분" },
    { value: "20", label: "20분" },
    { value: "30", label: "30분" },
    { value: "40", label: "40분" },
    { value: "50", label: "50분" },
];

const conditionOptions = [
    { value: "까지", label: "까지" },
    { value: "예식", label: "예식" },
    { value: "행사", label: "행사" },
    { value: "도착", label: "도착" },
];

const NewOrder = ({ onComplete }: { onComplete: () => void }) => {
    const { showPop } = useSystemPopStore();
    const level = useAuthStore(state => state.m_level);
    const [tempFileImages, setTempFileImages] = useState<File[]>([]);
    const today = new Date();
    const formattedToday =
        today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");

    const [checkedManager, setCheckedManager] = useState<{ [key: number]: boolean }>({});
    const [orderData, setOrderData] = useState({
        customer_idx: "",
        customer_name: "",
        order_name: "",
        order_mobile: "",
        product_idx: "",
        sales_amount: "",
        order_amount: "",
        wreath_sender: "",
        wreath_word: "",
        recipient_name: "",
        recipient_mobile: "",
        is_union: false,
        event_content_idx: "",
        related_person: "",
        work_location: "",
        department: "",
        company_tel: "",
        delivery_immediate: false,
        delivery_time: "",
        delivery_date: "",
        delivery_post: "",
        delivery_address: "",
        delivery_address_detail: "",
        delivery_memo_idx: "",
        delivery_memo: "",
        file_memo: "",
        order_memo: "",
        event_content: "",
        order_file: [] as File[],
        customer_request: "",
        product_quantity: 1,
    });
    const [customerTxt, setCustomerTxt] = useState<string>("");
    const [isCustomInput, setIsCustomInput] = useState(false);
    const [isOrderInput, setIsOrderInput] = useState(false);
    const [productPop, setProductPop] = useState<boolean>(false);
    const [imagePopup, setImagePopup] = useState<string | null>(null);
    const [selectedProduct, setSelectedProduct] = useState({
        product_idx: 0,
        product_image: "",
        product_code: "",
        product_code_name: "",
        product_category: "",
        product_category_idx: 0,
        product_union: false,
        product_name: "",
        product_amount: 0,
    });
    const [currentPage, setCurrentPage] = useState<number | null>(1);
    const [inputValue, setInputValue] = useState<string>(currentPage?.toString() || "");
    const [search, setSearch] = useState<string>("category_name");
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [sender, setSender] = useState<string>();
    const [senderTxt, setSenderTxt] = useState<string>("");
    const [word, setWord] = useState<string>();
    const [wordTxt, setWordTxt] = useState<string>("");
    const [deliveryMemo, setDeliveryMemo] = useState<string>("");
    const [event, setEvent] = useState<number | string>(0);
    const [selectedSenderValue, setSelectedSenderValue] = useState<string | undefined>();
    const [selectedWordValue, setSelectedWordValue] = useState<string | undefined>();
    const [customerNameError, setCustomerNameError] = useState<boolean>(false);
    const [customerCustomError, setCustomerCustomError] = useState<boolean>(false);
    const [memberNameError, setMemberNameError] = useState<boolean>(false);
    const [mobileError, setMobileError] = useState<boolean>(false);
    const [productIdxError, setProductIdxError] = useState<boolean>(false);
    const [receiverError, setReceiverError] = useState<boolean>(false);
    const [receiverMobileError, setReceiverMobileError] = useState<boolean>(false);
    const [eventError, setEventError] = useState<boolean>(false);
    const [dateError, setDateError] = useState<boolean>(false);
    const [timeError, setTimeError] = useState<boolean>(false);
    const [isOrdererOpen, setIsOrdererOpen] = useState(true);
    const [isMemoOpen, setIsMemoOpen] = useState(true);
    const [isProductOpen, setIsProductOpen] = useState(true);
    const [isReceiverOpen, setIsReceiverOpen] = useState(true);
    const [files, setFiles] = useState<File[]>([]);
    const [uploadPop, setUploadPop] = useState(false);
    const [previewImage, setPreviewImage] = useState<string | null>(null);
    const [isTalkManager, setIsTalkManager] = useState<boolean>(true);
    const textOnlyHourOptions = ["오전중", "오후중", "당일배송"];

    const { data: customerData } = useGetOrderCustomer(customerTxt);
    const { data: productData } = useGetOrderProduct(currentPage ?? 1, search, searchTxt);
    const { data: senderData } = useGetCommonSender(orderData.customer_idx, senderTxt, undefined, selectedProduct.product_category_idx);
    const { data: wordData } = useGetCommonWords(wordTxt);
    const { data: memoData } = useGetCommonMemo();
    const { data: eventData } = useGetCommonEvent();
    const { data: event2Data } = useGetCommonEvent(Number(event));
    const { data: managerData } = useGetOrderManager(orderData.customer_idx || "");
    const { data: cusMemoData } = useGetCustomerMemo(Number(orderData.customer_idx) || 0);

    const selectedManagerIdxList = Object.entries(checkedManager)
        .filter(([_, isChecked]) => isChecked)
        .map(([key]) => Number(key));

    const handleChange = (field: string, value: string) => {
        setOrderData(prev => {
            if (["delivery_hour", "delivery_minute", "delivery_condition"].includes(field)) {
                const deliveryHour = field === "delivery_hour" ? value : prev.delivery_time.split(" ")[0];
                const deliveryMinute = field === "delivery_minute" ? value : prev.delivery_time.split(" ")[1];
                const deliveryCondition = field === "delivery_condition" ? value : prev.delivery_time.split(" ")[2] || "까지";
                return {
                    ...prev,
                    delivery_time: `${deliveryHour} ${deliveryMinute} ${deliveryCondition}`,
                };
            }
            const isNumberField = ["sales_amount", "order_amount"].includes(field);
            if (isNumberField) {
                const numericValue = value.replace(/[^0-9]/g, "");
                return { ...prev, [field]: numericValue === "" ? 0 : Number(numericValue) };
            }
            if (field === "product_quantity") {
                const quantity = Number(value.replace(/[^0-9]/g, ""));
                const newSalesAmount = selectedProduct.product_amount * quantity;
                return {
                    ...prev,
                    [field]: quantity,
                    sales_amount: newSalesAmount.toString(),
                };
            }
            return { ...prev, [field]: value };
        });
    };
    const formatTelNumber = (value: string, prevValue: string, cursorPosition?: number) => {
        const onlyNumbers = value.replace(/\D/g, ""); // 숫자만 유지
        let formatted = "";

        // 3자리 지역번호 목록
        const threeDigitAreaCodes = [
            "031",
            "032",
            "033",
            "041",
            "042",
            "043",
            "051",
            "052",
            "053",
            "054",
            "055",
            "061",
            "062",
            "063",
            "064",
        ];

        const isSeoul = onlyNumbers.startsWith("02");
        const isThreeDigitAreaCode = threeDigitAreaCodes.some(code => onlyNumbers.startsWith(code));
        const isMobileOrOther = !isSeoul && !isThreeDigitAreaCode;

        // ✅ 안심번호 판단 기준: 050으로 시작하고 12자리
        const isSafeNumber = onlyNumbers.startsWith("050") && onlyNumbers.length === 12;

        const maxLength = isSafeNumber ? 12 : isSeoul ? 10 : 11;

        if (onlyNumbers.length > maxLength) return { formatted: prevValue, cursorOffset: 0 };

        if (isSafeNumber) {
            // ✅ 050 안심번호: 4-4-4 포맷
            formatted = `${onlyNumbers.slice(0, 4)}-${onlyNumbers.slice(4, 8)}-${onlyNumbers.slice(8, 12)}`;
        } else if (isSeoul) {
            if (onlyNumbers.length <= 2) {
                formatted = onlyNumbers;
            } else if (onlyNumbers.length <= 5) {
                formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2)}`;
            } else if (onlyNumbers.length <= 9) {
                formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2, 5)}-${onlyNumbers.slice(5)}`;
            } else {
                formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2, 6)}-${onlyNumbers.slice(6)}`;
            }
        } else {
            if (onlyNumbers.length <= 3) {
                formatted = onlyNumbers;
            } else if (onlyNumbers.length <= 6) {
                formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3)}`;
            } else if (onlyNumbers.length <= 10) {
                formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 6)}-${onlyNumbers.slice(6)}`;
            } else {
                formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 7)}-${onlyNumbers.slice(7)}`;
            }
        }

        // 커서 위치 보정
        const dashCountBefore = (prevValue.slice(0, cursorPosition).match(/-/g) || []).length;
        const dashCountAfter = (formatted.slice(0, cursorPosition).match(/-/g) || []).length;
        const cursorOffset = dashCountAfter - dashCountBefore;

        return { formatted, cursorOffset };
    };
    const handlePhoneNumberChange = (type: "order_mobile" | "recipient_mobile" | "company_tel", value: string) => {
        setOrderData(prev => {
            const inputElement = document.activeElement as HTMLInputElement;
            const cursorPosition = inputElement.selectionStart ?? value.length;

            const { formatted, cursorOffset } = formatTelNumber(value, prev[type], cursorPosition);
            const newCursorPosition = cursorPosition + cursorOffset;

            setTimeout(() => {
                inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
            }, 0);

            return { ...prev, [type]: formatted };
        });
    };
    const handleCustomerSelect = (value: string, label: string) => {
        if (value === "custom") {
            setIsCustomInput(true);
            setOrderData(prev => ({
                ...prev,
                customer_idx: "custom",
                customer_name: "",
                order_memo: "",
            }));
        } else {
            setIsCustomInput(false);
            setOrderData(prev => ({
                ...prev,
                customer_idx: value,
                customer_name: label,
                order_memo: "",
            }));
        }
    };
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setInputValue(page.toString());
    };
    const handlePageInput = (value: string) => {
        if (value.trim() === "") {
            setInputValue("");
            return;
        }
        if (!/^\d*$/.test(value)) {
            return;
        }
        const pageNumber = Number(value.trim());
        if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > (productData?.last_page || 1)) {
            alert("페이지 범위를 벗어났습니다.");
            setInputValue(value.slice(0, -1));
            return;
        }

        setInputValue(value);
        handlePageChange(pageNumber);
    };
    const handleProductSelect = (product: any) => {
        setOrderData(prev => ({
            ...prev,
            sales_amount: product.product_amount,
        }));
        setOrderData(prev => ({ ...prev, is_union: product.product_category.union_option }));
        setSelectedProduct({
            product_idx: product.product_idx,
            product_image: product?.product_image?.file_name,
            product_category: product.product_category.category_name,
            product_category_idx: product.product_category.product_category_idx,
            product_union: product.product_category.union_option,
            product_code: product.product_code,
            product_code_name: product.product_code_name,
            product_name: product.product_name,
            product_amount: product.product_amount,
        });
        setOrderData(prev => ({
            ...prev,
            product_idx: product.product_idx.toString(),
        }));
        setProductPop(false);
    };

    const postOrderMutation = usePostOrder(() => {
        onComplete();
    });

    //첨부파일
    const openImageUploadPop = () => {
        setUploadPop(true);
        setTempFileImages([...files]);
    };
    const handlePreviewImage = (image: string | File) => {
        const imageUrl = typeof image === "string" ? image : URL.createObjectURL(image);
        setPreviewImage(imageUrl);
    };
    const handleFiles = (files: File[]) => {
        setTempFileImages(prev => [...prev, ...files].slice(0, 4));
    };
    const handleImageDrop = (e: React.DragEvent<HTMLElement>) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);

        const totalFiles = tempFileImages.length + files.length;

        if (totalFiles > 4) {
            showPop({
                title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                type: "negative",
                onRightClick: () => {},
            });
            return;
        }

        handleFiles(files);
    };
    const handleRemoveImage = (index: number, isPopup: boolean = false) => {
        if (isPopup) {
            setTempFileImages(prev => prev.filter((_, i) => i !== index));
        } else {
            setFiles(prev => prev.filter((_, i) => i !== index));
        }
    };
    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const files = Array.from(e.target.files);
            if (files.length + tempFileImages.length > 4) {
                showPop({
                    title: "이미지는 최대 4장까지 <br /> 등록할 수 있습니다.",
                    type: "negative",
                    onRightClick: () => {},
                });
                return;
            }

            setTempFileImages(prev => [...prev, ...files].slice(0, 4));
        }
    };
    const handleConfirmImages = () => {
        setFiles(tempFileImages);
        setUploadPop(false);
    };

    const handleSubmit = () => {
        let hasError = false;
        let finalDeliveryTime = "";

        const textOnlyHourOptions = ["오전중", "오후중", "당일배송"];
        const [hour, minute, condition] = orderData.delivery_time.split(" ");
        const isTextOnlyHour = textOnlyHourOptions.includes(hour);

        const hourLabel = hoursOptions.find(opt => opt.value === hour)?.value ?? hour;

        const minuteLabel = isTextOnlyHour ? "" : (minutesOptions.find(opt => opt.value === minute)?.label ?? "");
        const conditionLabel = isTextOnlyHour ? "" : (condition ?? "");

        if (!orderData.customer_idx.trim() || !orderData.customer_name.trim()) {
            setCustomerNameError(true);
            hasError = true;
        } else {
            setCustomerNameError(false);
        }

        if (isCustomInput && !orderData.customer_name.trim()) {
            setCustomerCustomError(true);
            hasError = true;
        } else {
            setCustomerCustomError(false);
        }

        if (!orderData.order_name.trim()) {
            setMemberNameError(true);
            hasError = true;
        } else {
            setMemberNameError(false);
        }

        if (!orderData.order_mobile.trim()) {
            setMobileError(true);
            hasError = true;
        } else {
            setMobileError(false);
        }

        if (!orderData.product_idx.trim()) {
            setProductIdxError(true);
            hasError = true;
        } else {
            setProductIdxError(false);
        }

        if (!orderData.recipient_name.trim()) {
            setReceiverError(true);
            hasError = true;
        } else {
            setReceiverError(false);
        }

        if (!orderData.recipient_mobile.trim()) {
            setReceiverMobileError(true);
            hasError = true;
        } else {
            setReceiverMobileError(false);
        }

        if (!orderData.event_content_idx.trim()) {
            setEventError(true);
            hasError = true;
        } else {
            setEventError(false);
        }

        if (!orderData.delivery_date.trim()) {
            setDateError(true);
            hasError = true;
        } else {
            setDateError(false);
        }
        if (!orderData.delivery_immediate) {
            if (!hour || (!isTextOnlyHour && (!minute || !condition))) {
                setTimeError(true);
                hasError = true;
            } else {
                setTimeError(false);
            }

            finalDeliveryTime = isTextOnlyHour ? hourLabel : `${hourLabel} ${minuteLabel} ${conditionLabel}`.trim();
        } else {
            finalDeliveryTime = "";
        }

        if (hasError) return;

        const submitData = {
            ...orderData,
            delivery_time: finalDeliveryTime,
            order_file: files,
            customer_idx: orderData.customer_idx === "custom" ? "" : orderData.customer_idx,
            customer_manager_idx: selectedManagerIdxList,
        };

        // console.log("submitData", submitData);
        // return;

        showPop({
            title: "해당 주문건을 등록하시겠습니까?",
            content: "해당 주문건은 주문상태 [미확인], <br />발주상태는 [본점]으로 신규등록됩니다.",
            rightButton: "확인",
            type: "positive",
            onRightClick: () => {
                postOrderMutation.mutate(submitData, {
                    onError: (error: any) => {
                        const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";
                        showPop({
                            title: errorMessage,
                            rightButton: undefined,
                            type: "positive",
                            onRightClick: () => {},
                        });
                    },
                });
            },
        });
    };

    useEffect(() => {
        if (event === "1") {
            setOrderData(prev => ({
                ...prev,
                event_content_idx: "1",
            }));
        }
    }, [event]);
    useEffect(() => {
        if (event !== "1" && event2Data?.data?.length) {
            setOrderData(prev => ({
                ...prev,
                event_content_idx: event2Data.data[0].event_content_idx.toString(),
            }));
        }
    }, [event, event2Data]);
    useEffect(() => {
        const handlePaste = (e: ClipboardEvent) => {
            const items = e.clipboardData?.items;
            if (items) {
                const images: File[] = [];
                for (let i = 0; i < items.length; i++) {
                    if (items[i].kind === "file") {
                        const file = items[i].getAsFile();
                        if (file && file.type.startsWith("image/")) {
                            images.push(file);
                        }
                    }
                }
                if (images.length > 0) {
                    handleFiles(images);
                }
            }
        };
        document.addEventListener("paste", handlePaste);
        return () => document.removeEventListener("paste", handlePaste);
    }, [uploadPop]);
    useEffect(() => {
        if (memoData && memoData.data.length > 0 && !orderData.delivery_memo_idx) {
            setDeliveryMemo(memoData.data[0].delivery_memo_idx.toString());
            setOrderData(prev => ({
                ...prev,
                delivery_memo: "",
                delivery_memo_idx: memoData.data[0].delivery_memo_idx.toString(),
            }));
        }
    }, [memoData]);
    useEffect(() => {
        if (managerData?.data) {
            const init = managerData.data.reduce(
                (acc, cur) => {
                    acc[cur.customer_manager_idx] = false;
                    return acc;
                },
                {} as { [key: number]: boolean },
            );

            setCheckedManager(init);
        }
    }, [managerData]);
    useEffect(() => {
        if (cusMemoData && Array.isArray(cusMemoData?.data) && cusMemoData.data.length > 0) {
            const combinedMemo = cusMemoData.data.map(memo => memo.customer_memo).join("\n");

            setOrderData(prev => ({
                ...prev,
                order_memo: combinedMemo,
            }));
        }
    }, [cusMemoData]);

    const [managerTxt, setManagerTxt] = useState("");

    // managerData 가 있을 때 ㄱㄴㄷ 정렬
    const sortedManagers = managerData?.data
        ? [...managerData.data].sort((a, b) => a.manager_name.localeCompare(b.manager_name, "ko"))
        : [];

    // 검색된 값 필터링 (managerTxt 사용)
    const filteredManagers = sortedManagers.filter(
        manager => manager.manager_name.includes(managerTxt), // 부분검색
    );

    console.log('imagePop',imagePopup);

    return (
        <div className="bg-white rounded-xl">
            <p className="text-2xl font-bold py-5 px-6">신규주문 등록</p>
            <div className="p-3 flex flex-col gap-5">
                <div className="flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                        <p className="text-gray2 font-bold">주문자</p>
                        <DownArrow
                            onClick={() => setIsOrdererOpen(!isOrdererOpen)}
                            className={`${isOrdererOpen ? "rotate-180" : "rotate-0"} transition-transform cursor-pointer`}
                        />
                    </div>
                    {isOrdererOpen && (
                        <div className="border-t-2 border-gray2 ">
                            <div className="flex items-center border-b border-gray4">
                                <TableName className="h-12" required>
                                    고객
                                </TableName>
                                <SelectBox
                                    height="max-h-80"
                                    onSearchChange={value => setCustomerTxt(value)}
                                    onChange={value => {
                                        const selectedOption = customerData?.find(customer => customer.customer_idx.toString() === value);
                                        if (value === "custom") {
                                            // handleCustomerSelect(value, "");
                                        } else if (selectedOption) {
                                            handleCustomerSelect(value, selectedOption.customer_name);
                                        }
                                        setCustomerNameError(false);
                                    }}
                                    value={orderData.customer_idx}
                                    searchable
                                    options={[
                                        // { value: "custom", label: "직접입력" },
                                        ...(customerData
                                            ? customerData.map(customer => ({
                                                  value: customer.customer_idx.toString(),
                                                  label: customer.customer_name,
                                              }))
                                            : []),
                                        ...(orderData.customer_idx &&
                                        !customerData?.some(customer => customer.customer_idx.toString() === orderData.customer_idx)
                                            ? [{ value: orderData.customer_idx, label: orderData.customer_name }]
                                            : []),
                                    ]}
                                    className="w-full bg-white z-50 px-2"
                                    placeholder="등록된 고객(+ 부서) 리스트 선택"
                                    full
                                    status={customerNameError ? "error" : ""}
                                />
                            </div>
                            {isCustomInput && (
                                <div className="flex items-center border-b border-gray4">
                                    <TableName className="h-12" required>
                                        직접입력
                                    </TableName>
                                    <Input
                                        status={customerCustomError ? "error" : ""}
                                        placeholder="30자"
                                        className="w-full px-2"
                                        value={orderData.customer_name}
                                        onChange={e => {
                                            setOrderData(prev => ({
                                                ...prev,
                                                customer_name: e.target.value,
                                            }));
                                        }}
                                    />
                                </div>
                            )}
                            <div className="flex border-b border-gray4 items-center">
                                <div className={`flex items-center ${isOrderInput ? "w-1/2" : "w-full"}`}>
                                    <TableName className="h-12" required>
                                        이름
                                    </TableName>
                                    <SelectBox
                                        onSearchChange={value => setManagerTxt(value)}
                                        onChange={selectedValue => {
                                            if (selectedValue === "custom") {
                                                setIsOrderInput(true);
                                                handleChange("order_name", "");
                                                handleChange("order_mobile", "");
                                            } else {
                                                setIsOrderInput(false);
                                                const selectedManager = managerData?.data?.find(
                                                    manager => String(manager.customer_manager_idx) === selectedValue,
                                                );
                                                if (selectedManager) {
                                                    handleChange("order_name", selectedManager.manager_name);
                                                    handleChange("order_mobile", selectedManager.manager_mobile);
                                                }
                                            }
                                            setMemberNameError(false);
                                        }}
                                        options={[
                                            { value: "custom", label: "직접입력" },
                                            ...filteredManagers.map(manager => ({
                                                value: String(manager.customer_manager_idx),
                                                label: manager.manager_name,
                                            })),
                                        ]}
                                        className="w-full px-2"
                                        value={
                                            isOrderInput
                                                ? "custom"
                                                : managerData?.data
                                                      ?.find(manager => manager.manager_name === orderData.order_name)
                                                      ?.customer_manager_idx?.toString() || ""
                                        }
                                        searchable={orderData.customer_idx && orderData.customer_idx !== "custom" ? true : false}
                                        status={memberNameError ? "error" : undefined}
                                    />
                                </div>
                                {isOrderInput && (
                                    <Input
                                        placeholder="이름 입력"
                                        maxLength={20}
                                        className="w-1/2 my-[7px] mr-[7px] ml-[3px]"
                                        value={orderData.order_name === "custom" ? "" : orderData.order_name}
                                        onChange={e => {
                                            handleChange("order_name", e.target.value);
                                            setSelectedWordValue(undefined);
                                        }}
                                    />
                                )}
                            </div>
                            <div className="flex items-center border-b border-gray4 w-full">
                                <TableName className="h-12" required>
                                    연락처
                                </TableName>
                                <Input
                                    className="px-2 w-full"
                                    value={orderData.order_mobile}
                                    onChange={e => handlePhoneNumberChange("order_mobile", e.target.value)}
                                    status={mobileError ? "error" : undefined}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                        <p className="text-gray2 font-bold">알림톡 수신 담당자</p>
                        <DownArrow
                            onClick={() => setIsTalkManager(!isTalkManager)}
                            className={`${isTalkManager ? "rotate-180" : "rotate-0"} transition-transform cursor-pointer`}
                        />
                    </div>
                    {isTalkManager && (
                        <div className="border-t-2 border-gray2 ">
                            <div className="flex items-stretch border-b min-h-12 border-gray4">
                                <TableName>담당자</TableName>
                                <div className="flex flex-col justify-center p-2">
                                    {managerData?.data.map(manager => (
                                        <div key={manager.customer_manager_idx} className="flex text-sm items-center gap-2">
                                            <CheckBox
                                                checked={checkedManager[manager.customer_manager_idx] ?? false}
                                                onChange={() =>
                                                    setCheckedManager(prev => ({
                                                        ...prev,
                                                        [manager.customer_manager_idx]: !prev[manager.customer_manager_idx],
                                                    }))
                                                }
                                            />
                                            <p>{manager.manager_name}</p>
                                            <p>{manager.manager_mobile}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                        <p className="text-gray2 font-bold">업무용 메모</p>
                        <DownArrow
                            onClick={() => setIsMemoOpen(!isMemoOpen)}
                            className={`${isMemoOpen ? "rotate-180" : "rotate-0"} transition-transform cursor-pointer`}
                        />
                    </div>
                    {isMemoOpen && (
                        <div className="border-t-2 border-gray2">
                            <div className="flex border-b border-gray4 items-stretch">
                                <TableName className="">메모</TableName>
                                <textarea
                                    disabled={level === 7}
                                    className="px-3 py-2 mx-2 h-auto my-[7px] placeholder:text-grayicon focus:border-primary1 outline-0 rounded-lg w-full text-sm border border-gray4 resize-none overflow-hidden"
                                    placeholder="직접 입력"
                                    value={orderData.order_memo}
                                    onChange={e => handleChange("order_memo", e.target.value)}
                                    onInput={e => {
                                        e.currentTarget.style.height = "auto";
                                        e.currentTarget.style.height = `${e.currentTarget.scrollHeight}px`;
                                    }}
                                    rows={1}
                                    style={{ minHeight: "97px" }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                        <p className="text-gray2 font-bold">상품정보</p>
                        <DownArrow
                            onClick={() => setIsProductOpen(!isProductOpen)}
                            className={`${isProductOpen ? "rotate-180" : "rotate-0"} transition-transform cursor-pointer`}
                        />
                    </div>
                    {isProductOpen && (
                        <div className="border-t-2 border-gray2">
                            <div className="flex border-b border-gray4 items-stretch">
                                <TableName required>상품</TableName>
                                <div className="flex p-2 items-center justify-between w-full">
                                    {selectedProduct.product_idx === 0 ? (
                                        <p className="text-sm text-grayicon">고객 선택 후, 상품을 선택하실 수 있습니다.</p>
                                    ) : (
                                        <>
                                        <div className="flex items-center gap-4 cursor-pointer" onClick={() => setImagePopup(`${api_uri}/${selectedProduct.product_image}`)}>
                                            {selectedProduct.product_image && (
                                                <img
                                                    className="w-[60px] h-[60px] object-contain rounded-xl flex items-center justify-center text-xs"
                                                    src={`${api_uri}/${selectedProduct.product_image}`}
                                                    alt="Product Image"
                                                />
                                            )}
                                            <div className="flex flex-col">
                                                <div className="flex text-sm gap-2">
                                                    <p className="text-gray3">{selectedProduct.product_category}</p>
                                                    {selectedProduct.product_code && (
                                                        <p>{/* {selectedProduct.product_code_name} / {selectedProduct.product_code} */}</p>
                                                    )}
                                                </div>
                                                <div className="flex gap-2 items-center  max-w-56 md:max-w-72">
                                                    <p className="text-lg font-bold truncate">{selectedProduct.product_name}</p>
                                                    <p className="whitespace-nowrap">{selectedProduct.product_amount.toLocaleString()}원</p>
                                                </div>
                                            </div>
                                        </div>
                                           {imagePopup && (
                                                <div
                                                    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[101]"
                                                    onClick={() => setImagePopup(null)}
                                                >
                                                    <img
                                                        src={imagePopup}
                                                        alt="Product Image"
                                                        className="max-w-[90vw] max-h-[90vh] object-contain rounded-xl"
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </div>
                                            )}
                                        </>
                                    )}

                                    <Button
                                        status={productIdxError ? "error" : ""}
                                        size="S"
                                        onClick={() => {
                                            setProductPop(true);
                                            setProductIdxError(false);
                                        }}
                                        className="px-2"
                                        icon={<Select />}
                                        iconPosition="right"
                                    >
                                        상품 선택
                                    </Button>
                                    {productPop && (
                                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                            <div className="bg-white rounded-2xl shadow-custom w-full max-w-[1100px] py-5 px-6">
                                                <div className="flex justify-between items-center p-3">
                                                    <div className="flex items-center gap-5">
                                                        <h2 className="text-2xl font-bold">상품 선택</h2>
                                                        <div className="flex items-center gap-2">
                                                            <FileSearch />
                                                            <p className="underline cursor-pointer">상품 관리</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-5">
                                                        <div className="flex items-center gap-2">
                                                            <button
                                                                onClick={() =>
                                                                    currentPage && currentPage > 1 && handlePageChange(currentPage - 1)
                                                                }
                                                            >
                                                                <LeftArrow />
                                                            </button>
                                                            <Input
                                                                inputClassName="text-center"
                                                                className="w-20 text-center outline-0 text-sm flex"
                                                                value={inputValue}
                                                                onChange={e => handlePageInput(e.target.value)}
                                                            />
                                                            <p className="text-gray3">/ {productData?.last_page}</p>
                                                            <button
                                                                onClick={() =>
                                                                    currentPage &&
                                                                    currentPage < (productData?.last_page || 1) &&
                                                                    handlePageChange(currentPage + 1)
                                                                }
                                                            >
                                                                <RightArrow />
                                                            </button>
                                                        </div>
                                                        <CloseBlackIcon
                                                            className="cursor-pointer"
                                                            onClick={() => {
                                                                setProductPop(false);
                                                                setCurrentPage(1);
                                                                setInputValue("1");
                                                                setSearchTxt("");
                                                                setSearch("category_name");
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="px-3 py-2 flex justify-between items-center border-t border-gray4">
                                                    <div className="flex gap-2 items-center">
                                                        <p className="text-xs">총</p>
                                                        <p className="font-bold text-primary2 text-sm">{productData?.total_count}</p>
                                                    </div>
                                                    <div className="w-[350px] flex gap-1">
                                                        <SelectBox
                                                            status="none"
                                                            className="min-w-[110px]"
                                                            options={[
                                                                { value: "category_name", label: "카테고리명" },
                                                                { value: "product_name", label: "상품명" },
                                                            ]}
                                                            value={search}
                                                            onChange={(value: string) => setSearch(value)}
                                                        />
                                                        <Input
                                                            placeholder="검색"
                                                            status="none"
                                                            className="flex-1"
                                                            value={searchTxt}
                                                            onChange={e => {
                                                                setSearchTxt(e.target.value);
                                                                setCurrentPage(1);
                                                                setInputValue("1");
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <figure className="max-h-[65dvh] min-h-[65dvh] h-full overflow-auto border-t border-[#999999] pb-5">
                                                    <table className="min-w-[950px] w-full text-sm table-fixed text-gray2">
                                                        <colgroup>
                                                            <col width="20%" />
                                                            <col width="33%" />
                                                            <col width="20%" />
                                                            <col width="15%" />
                                                            <col width="12%" />
                                                        </colgroup>
                                                        <thead className="h-10 border-b border-[#DDDDDD]">
                                                            <tr>
                                                                <th className="text-start pl-2 sticky top-0 bg-[canvas]">카테고리</th>
                                                                <th className="text-start pl-2 sticky top-0 bg-[canvas]">상품명</th>
                                                                <th className="text-start pl-22 sticky top-0 bg-[canvas]">
                                                                    베스트플라워 발주
                                                                </th>
                                                                <th className="text-start pl-2 sticky top-0 bg-[canvas]">가격</th>
                                                                <th className="text-start pl-2 sticky top-0 bg-[canvas]">상품선택</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {productData?.data_list.length || -1 > 0 ? (
                                                                productData?.data_list.map((item, index) => (
                                                                    <tr key={index} className="text-center border-b border-[#DDDDDD]">
                                                                        <td className="text-start pl-2">
                                                                            {item?.product_category?.category_name}
                                                                        </td>
                                                                        <td className="text-center pl-2 overflow-hidden">
                                                                            <div className="flex items-center gap-4 min-h-12">
                                                                                {item?.product_image && (
                                                                                    <img
                                                                                        className="w-9 h-9 object-contain"
                                                                                        src={`${api_uri}/${item?.product_image?.file_name}`}
                                                                                        alt="Product Image"
                                                                                    />
                                                                                )}
                                                                                <span
                                                                                    className="block text-left"
                                                                                    style={{ wordBreak: "break-all" }}
                                                                                >
                                                                                    {item?.product_name}
                                                                                </span>
                                                                            </div>
                                                                        </td>

                                                                        <td className="text-start pl-2">
                                                                            {item?.product_code && (
                                                                                <p>
                                                                                    {item?.product_code_name} / {item?.product_code}
                                                                                </p>
                                                                            )}
                                                                        </td>
                                                                        <td className="text-start pl-2">
                                                                            {item?.product_amount.toLocaleString()}원
                                                                        </td>
                                                                        <td className="text-start">
                                                                            <Button
                                                                                size="S"
                                                                                className="px-2 whitespace-nowrap"
                                                                                onClick={() => handleProductSelect(item)}
                                                                            >
                                                                                상품 선택
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={4} className="py-40 text-center text-gray-500">
                                                                        상품 목록이 없습니다.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </figure>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="flex border-b border-gray4">
                                <div className="flex items-center w-full">
                                    <TableName className="h-12">고객 요청사항</TableName>
                                    <Input
                                        maxLength={50}
                                        className="px-2 w-full"
                                        value={orderData.customer_request.toLocaleString()}
                                        onChange={e => handleChange("customer_request", e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="flex border-b border-gray4">
                                <div className="flex items-center w-full">
                                    <TableName className="h-12">수량</TableName>
                                    <Input
                                        quantity
                                        maxLength={4}
                                        className="px-2 w-1/5"
                                        value={orderData.product_quantity.toLocaleString()}
                                        onChange={e => {
                                            const value = e.target.value.replace(/[^0-9]/g, "");
                                            handleChange("product_quantity", value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex border-b border-gray4">
                                <div className="flex items-center w-1/2">
                                    <TableName className="h-12">판매금액</TableName>
                                    <Input
                                        className="px-2"
                                        value={Number(orderData.sales_amount).toLocaleString()}
                                        onChange={e => handleChange("sales_amount", e.target.value.replace(/,/g, ""))}
                                        price
                                    />
                                </div>
                                <div className="flex items-center w-1/2">
                                    <TableName className="h-12">발주금액</TableName>
                                    <Input
                                        className="px-2"
                                        value={orderData.order_amount.toLocaleString()}
                                        onChange={e => handleChange("order_amount", e.target.value.replace(/,/g, ""))}
                                        price
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2.5">
                            <p className="text-gray2 font-bold">수신정보</p>
                            <Button
                                size="S"
                                className="px-2"
                                onClick={() => {
                                    setOrderData(prev => ({
                                        ...prev,
                                        recipient_name: orderData.order_name,
                                        recipient_mobile: orderData.order_mobile,
                                    }));
                                }}
                            >
                                주문자 정보와 동일
                            </Button>
                        </div>
                        <DownArrow
                            onClick={() => setIsReceiverOpen(!isReceiverOpen)}
                            className={`${isReceiverOpen ? "rotate-180" : "rotate-0"} transition-transform cursor-pointer`}
                        />
                    </div>
                    {isReceiverOpen && (
                        <div className="border-t-2 border-gray2 ">
                            <div className="flex border-b border-gray4">
                                <div className="flex  items-stretch w-full">
                                    <TableName className="">명의</TableName>
                                    <div className="flex flex-col w-full m-[7px] gap-[7px]">
                                        <SelectBox
                                            placeholder="선택"
                                            onSearchChange={value => setSenderTxt(value)}
                                            searchable
                                            options={
                                                senderData?.data
                                                    ? [
                                                          { value: "custom", label: "직접입력" },
                                                          ...senderData.data.map(sender => ({
                                                              value: sender.sender_idx.toString(),
                                                              label: selectedProduct.product_union
                                                                  ? sender.union_sender.replace(/</g, "&lt;").replace(/>/g, "&gt;")
                                                                  : sender.default_sender.replace(/</g, "&lt;").replace(/>/g, "&gt;"),
                                                          })),
                                                      ]
                                                    : [{ value: "custom", label: "직접입력" }]
                                            }
                                            full
                                            className="w-full"
                                            value={sender === "custom" ? "custom" : selectedSenderValue}
                                            onChange={value => {
                                                if (value === "custom") {
                                                    setSender("custom");
                                                    setOrderData(prev => ({
                                                        ...prev,
                                                        wreath_sender: "",
                                                    }));
                                                    setSelectedSenderValue(undefined);
                                                } else {
                                                    const selectedSender = senderData?.data.find(
                                                        sender => sender.sender_idx.toString() === value,
                                                    );
                                                    if (selectedSender) {
                                                        setOrderData(prev => ({
                                                            ...prev,
                                                            wreath_sender: selectedProduct.product_union
                                                                ? selectedSender.union_sender
                                                                : selectedSender.default_sender,
                                                        }));
                                                        setSender(undefined);
                                                        setSelectedSenderValue(value);
                                                    }
                                                }
                                            }}
                                        />
                                        {sender === "custom" && (
                                            <textarea
                                                disabled={level === 7}
                                                placeholder="100자"
                                                maxLength={100}
                                                className="px-3 py-2 h-auto placeholder:text-grayicon focus:border-primary1 outline-0 rounded-lg w-full text-sm border border-gray4 resize-none overflow-hidden"
                                                rows={1}
                                                style={{ minHeight: "8px" }}
                                                value={orderData.wreath_sender}
                                                onChange={e => {
                                                    setOrderData(prev => ({
                                                        ...prev,
                                                        wreath_sender: e.target.value,
                                                    }));
                                                    setSelectedSenderValue(undefined);
                                                }}
                                                onInput={e => {
                                                    e.currentTarget.style.height = "auto";
                                                    e.currentTarget.style.height = `${Math.max(e.currentTarget.scrollHeight, 8)}px`;
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="flex border-b border-gray4 items-stretch w-full">
                                <TableName className="">경조사어</TableName>
                                <div className="flex flex-col w-full m-[7px] gap-[7px]">
                                    <SelectBox
                                        height="max-h-64"
                                        placeholder="선택"
                                        onSearchChange={value => setWordTxt(value)}
                                        searchable
                                        options={
                                            wordData?.data
                                                ? [
                                                      { value: "custom", label: "직접입력" },
                                                      ...wordData.data.map(word => ({
                                                          value: word.word_idx.toString(),
                                                          label: word.wreath_word + "(" + word.search_word + ")",
                                                      })),
                                                  ]
                                                : [{ value: "custom", label: "직접입력" }]
                                        }
                                        full
                                        className="w-full"
                                        value={word === "custom" ? "custom" : selectedWordValue}
                                        onChange={value => {
                                            if (value === "custom") {
                                                setWord("custom");
                                                setOrderData(prev => ({
                                                    ...prev,
                                                    wreath_word: "",
                                                }));
                                                setSelectedWordValue(undefined);
                                            } else {
                                                const selectedWord = wordData?.data.find(word => word.word_idx.toString() === value);
                                                if (selectedWord) {
                                                    setOrderData(prev => ({
                                                        ...prev,
                                                        wreath_word: selectedWord.wreath_word,
                                                    }));
                                                    setWord(undefined);
                                                    setSelectedWordValue(value);
                                                }
                                            }
                                        }}
                                    />
                                    {word === "custom" && (
                                        <Input
                                            placeholder="100자"
                                            maxLength={100}
                                            className="w-full"
                                            value={orderData.wreath_word}
                                            onChange={e => {
                                                setOrderData(prev => ({
                                                    ...prev,
                                                    wreath_word: e.target.value,
                                                }));
                                                setSelectedWordValue(undefined);
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex items-center border-b border-gray4 w-1/2">
                                    <TableName className="h-12" required>
                                        받으시는 분
                                    </TableName>
                                    <Input
                                        maxLength={40}
                                        status={receiverError ? "error" : ""}
                                        placeholder="40자"
                                        className="px-2"
                                        value={orderData.recipient_name}
                                        onChange={e => {
                                            setReceiverError(false);
                                            handleChange("recipient_name", e.target.value);
                                        }}
                                    />
                                </div>
                                <div className="flex items-center border-b border-gray4 w-1/2">
                                    <TableName className="h-12" required>
                                        연락처
                                    </TableName>
                                    <Input
                                        status={receiverMobileError ? "error" : ""}
                                        className="px-2"
                                        value={orderData.recipient_mobile}
                                        onChange={e => {
                                            handlePhoneNumberChange("recipient_mobile", e.target.value);
                                            setReceiverMobileError(false);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex border-b border-gray4">
                                <TableName className="h-12" required>
                                    노조가입
                                </TableName>
                                <Toggle
                                    isOn={orderData.is_union}
                                    onToggle={() => setOrderData(prev => ({ ...prev, is_union: !prev.is_union }))}
                                    className="px-2"
                                    onLabel="노동조합 가입"
                                    offLabel="노동조합 미가입"
                                />
                            </div>
                            <div className="flex border-b border-gray4">
                                <div className="flex w-1/2">
                                    <TableName className="h-12" required>
                                        경조내용
                                    </TableName>
                                    <SelectBox
                                        status={eventError ? "error" : ""}
                                        options={
                                            eventData?.data
                                                ? [
                                                      ...eventData.data.map(event => ({
                                                          value: event.depth1_idx.toString(),
                                                          label: event.depth1,
                                                      })),
                                                  ]
                                                : []
                                        }
                                        full
                                        className="w-full m-[7px]"
                                        value={event.toString()}
                                        onChange={value => {
                                            setEventError(false);
                                            setEvent(value);
                                        }}
                                    />
                                </div>
                                {event === "2" || event === 2 ? (
                                    <Input
                                        className="m-[7px] w-1/2"
                                        value={orderData.event_content}
                                        onChange={e =>
                                            setOrderData(prev => ({
                                                ...prev,
                                                event_content: e.target.value,
                                            }))
                                        }
                                    />
                                ) : (
                                    <SelectBox
                                        height="max-h-64"
                                        status={eventError ? "error" : ""}
                                        disabled={event === "1" || event === 1}
                                        disabledBG={event === "1" || event === 1}
                                        options={
                                            event2Data?.data
                                                ? event2Data.data.map(event => ({
                                                      value: event.event_content_idx.toString() || "",
                                                      label: event.depth2 || "",
                                                  }))
                                                : []
                                        }
                                        full
                                        className="w-1/2 m-[7px]"
                                        value={orderData.event_content_idx?.toString() || ""}
                                        onChange={value => {
                                            setEventError(false);
                                            setOrderData(prev => ({
                                                ...prev,
                                                event_content_idx: value,
                                            }));
                                        }}
                                    />
                                )}
                            </div>
                            <div className="flex border-b border-gray4">
                                <TableName className="h-12">대상자명</TableName>
                                <Input
                                    maxLength={100}
                                    placeholder="100자"
                                    className="p-2 w-full"
                                    value={orderData.related_person}
                                    onChange={e => handleChange("related_person", e.target.value)}
                                />
                            </div>
                            <div className="flex">
                                <div className="flex items-center border-b border-gray4 w-1/2">
                                    <TableName className="h-12">부서</TableName>
                                    <Input
                                        maxLength={100}
                                        placeholder="100자"
                                        className="px-2"
                                        value={orderData.department}
                                        onChange={e => handleChange("department", e.target.value)}
                                    />
                                </div>
                                <div className="flex items-center border-b border-gray4 w-1/2">
                                    <TableName className="h-12">사번</TableName>
                                    <Input
                                        maxLength={100}
                                        className="px-2"
                                        value={orderData.company_tel}
                                        onChange={e => {
                                            const newValue = e.target.value;
                                            setOrderData(prev => ({
                                                ...prev,
                                                company_tel: newValue,
                                            }));
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex border-b border-gray4">
                                <TableName className="h-12">근무지</TableName>
                                <Input
                                    placeholder="100자"
                                    maxLength={100}
                                    className="p-2 w-full"
                                    value={orderData.work_location}
                                    onChange={e => handleChange("work_location", e.target.value)}
                                />
                            </div>
                            <div className="flex border-b border-gray4">
                                <TableName className="h-12" required>
                                    즉시배송
                                </TableName>
                                <div className="px-2 flex items-center gap-1">
                                    <Toggle
                                        isOn={orderData.delivery_immediate}
                                        onToggle={() =>
                                            setOrderData(prev => ({
                                                ...prev,
                                                delivery_immediate: !prev.delivery_immediate,
                                                delivery_time: "",
                                                delivery_date: !prev.delivery_immediate ? formattedToday : "",
                                            }))
                                        }
                                        className="px-2"
                                        onLabel="즉시배송 활성화"
                                        offLabel="즉시배송 비활성화"
                                    />
                                </div>
                            </div>
                            <div className="flex items-center border-b border-gray4">
                                <TableName className="h-12" required>
                                    배송일자
                                </TableName>
                                <div className="h-12 w-full p-2">
                                    <DayPickerInput
                                        disabled={orderData.delivery_immediate}
                                        onDateChange={date => {
                                            setDateError(false);
                                            setOrderData(prev => ({
                                                ...prev,
                                                delivery_date: date
                                                    ? new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                          .toISOString()
                                                          .split("T")[0]
                                                    : "",
                                            }));
                                        }}
                                        className={`${dateError ? "border-error " : "border-gray4"} border h-full rounded-lg px-2`}
                                        initialDate={orderData.delivery_date ? new Date(orderData.delivery_date) : undefined}
                                    />
                                </div>
                            </div>
                            <div className="flex items-center border-b border-gray4">
                                <TableName className="h-12" required>
                                    배송시간
                                </TableName>
                                <div className="flex gap-1 w-full p-2">
                                    {/* 시 선택 */}
                                    <SelectBox
                                        height="max-h-52"
                                        disabledBG={orderData.delivery_immediate}
                                        placeholder="시 선택"
                                        disabled={orderData.delivery_immediate}
                                        status={timeError ? "error" : ""}
                                        className="w-full"
                                        options={hoursOptions}
                                        value={orderData.delivery_time.split(" ")[0] || ""}
                                        onChange={value => {
                                            setTimeError(false);
                                            const [, minute = "", condition = ""] = orderData.delivery_time.split(" ");
                                            const textOnly = textOnlyHourOptions.includes(value);
                                            handleChange("delivery_time", textOnly ? value : `${value} ${minute} ${condition}`.trim());
                                        }}
                                    />

                                    {/* 분 선택 */}
                                    <SelectBox
                                        disabledBG={
                                            orderData.delivery_immediate ||
                                            textOnlyHourOptions.includes(orderData.delivery_time.split(" ")[0])
                                        }
                                        placeholder="분 선택"
                                        disabled={
                                            orderData.delivery_immediate ||
                                            textOnlyHourOptions.includes(orderData.delivery_time.split(" ")[0])
                                        }
                                        status={timeError ? "error" : ""}
                                        className="w-full"
                                        options={minutesOptions}
                                        value={
                                            textOnlyHourOptions.includes(orderData.delivery_time.split(" ")[0])
                                                ? ""
                                                : orderData.delivery_time.split(" ")[1] || ""
                                        }
                                        onChange={value => {
                                            setTimeError(false);
                                            const [hour = "", , condition = ""] = orderData.delivery_time.split(" ");
                                            handleChange("delivery_time", `${hour} ${value} ${condition}`.trim());
                                        }}
                                    />

                                    {/* 조건 선택 (예: 까지) */}
                                    <SelectBox
                                        disabledBG={
                                            orderData.delivery_immediate ||
                                            textOnlyHourOptions.includes(orderData.delivery_time.split(" ")[0])
                                        }
                                        disabled={
                                            orderData.delivery_immediate ||
                                            textOnlyHourOptions.includes(orderData.delivery_time.split(" ")[0])
                                        }
                                        status={timeError ? "error" : ""}
                                        className="w-full"
                                        options={conditionOptions}
                                        value={
                                            orderData.delivery_immediate ||
                                            textOnlyHourOptions.includes(orderData.delivery_time.split(" ")[0])
                                                ? ""
                                                : orderData.delivery_time.split(" ")[2] || ""
                                        }
                                        onChange={value => {
                                            setTimeError(false);
                                            const [hour = "", minute = ""] = orderData.delivery_time.split(" ");
                                            handleChange("delivery_time", `${hour} ${minute} ${value}`.trim());
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex items-stretch border-b border-gray4">
                                <TableName className="">배송지 주소</TableName>
                                <NewOrderSearchAddress
                                    post={orderData.delivery_post}
                                    customerAddress={orderData.delivery_address}
                                    customerAddressDetail={orderData.delivery_address_detail}
                                    onAddressChange={(newZoneCode, newAddress, newDetailAddress) => {
                                        setOrderData(prev => ({
                                            ...prev,
                                            delivery_post: newZoneCode,
                                            delivery_address: newAddress,
                                            delivery_address_detail: newDetailAddress,
                                        }));
                                    }}
                                />
                            </div>
                            <div className="flex border-b border-gray4">
                                <div className={`flex ${deliveryMemo === "1" ? "w-1/2" : "w-full"}`}>
                                    <TableName className="h-12">배송 메모</TableName>
                                    <SelectBox
                                        height="max-h-40"
                                        placeholder="선택"
                                        options={
                                            memoData?.data
                                                ? [
                                                      ...memoData.data.map(memo => ({
                                                          value: memo.delivery_memo_idx.toString(),
                                                          label: memo.delivery_memo,
                                                      })),
                                                  ]
                                                : []
                                        }
                                        full
                                        className="w-full m-[7px]"
                                        value={orderData.delivery_memo_idx ? orderData.delivery_memo_idx.toString() : ""}
                                        onChange={value => {
                                            setDeliveryMemo(value);
                                            if (value === "1") {
                                                setOrderData(prev => ({
                                                    ...prev,
                                                    delivery_memo: "",
                                                    delivery_memo_idx: "1",
                                                }));
                                            } else {
                                                const selectedMemo = memoData?.data.find(
                                                    memo => memo.delivery_memo_idx.toString() === value,
                                                );
                                                if (selectedMemo) {
                                                    setOrderData(prev => ({
                                                        ...prev,
                                                        delivery_memo: selectedMemo.delivery_memo,
                                                        delivery_memo_idx: selectedMemo.delivery_memo_idx.toString(),
                                                    }));
                                                }
                                            }
                                        }}
                                    />
                                </div>

                                {deliveryMemo === "1" && (
                                    <Input
                                        maxLength={100}
                                        placeholder="100자"
                                        className="m-[7px] w-1/2"
                                        value={orderData.delivery_memo}
                                        onChange={e => {
                                            const newValue = e.target.value;

                                            const isExistingMemo = memoData?.data.some(memo => memo.delivery_memo === newValue);

                                            setOrderData(prev => ({
                                                ...prev,
                                                delivery_memo: newValue,
                                                delivery_memo_idx: isExistingMemo ? prev.delivery_memo_idx : "1",
                                            }));
                                        }}
                                    />
                                )}
                            </div>

                            <div className="flex items-stretch border-b border-gray4 relative">
                                <TableName className=" h-auto">
                                    초대장, <br />
                                    청첩장, <br />
                                    부고장 정보
                                </TableName>
                                <div className="w-full p-2 flex flex-col gap-1">
                                    <div className="flex gap-2 flex-wrap w-full">
                                        {files.length >= 1 && (
                                            <div
                                                className={`${uploadPop ? "border-primary2 text-primary2" : " border-gray5 border-dashed text-grayicon"}  ${level === 7 ? "cursor-default" : "cursor-pointer"}  w-[60px] flex flex-col items-center border rounded-xl p-2`}
                                                onClick={() => level !== 7 && openImageUploadPop()}
                                            >
                                                <PlusIcon />
                                                <p className="text-sm">추가</p>
                                            </div>
                                        )}
                                        {files.map((image, index) => (
                                            <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                                <img
                                                    alt="image"
                                                    src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                    className="w-full h-full object-contain cursor-pointer"
                                                    onClick={() => handlePreviewImage(image)}
                                                />
                                                {level !== 7 && (
                                                    <button
                                                        className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                        onClick={() => handleRemoveImage(index, false)}
                                                    >
                                                        <CloseIcon />
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {files.length < 1 && (
                                            <div
                                                className={`
                                            ${uploadPop ? "bg-primary4 border-primary2 text-primary2" : "border-gray5 border-dashed text-grayicon"}  ${level === 7 ? "cursor-default" : "cursor-pointer"}  w-full flex flex-col items-center border  rounded-xl p-2
                                        `}
                                                onClick={() => level !== 7 && openImageUploadPop()}
                                            >
                                                {uploadPop ? <UploadOnImage /> : <UploadImage />}
                                                <p className="text-sm">이미지 업로드</p>
                                            </div>
                                        )}
                                    </div>
                                    {/* 이미지 업로드 팝업 */}
                                    {uploadPop && (
                                        <div className="flex flex-col z-50 absolute w-[400px] bg-white rounded-2xl shadow-custom translate-y-[60px]">
                                            <div className="flex w-full  items-center px-5 justify-between py-5 ">
                                                <p className="text-primary1 text-2xl font-bold">이미지 업로드</p>
                                                <p className="text-sm">최대 4장까지 업로드 가능합니다.</p>
                                                <CloseBlackIcon className="cursor-pointer" onClick={() => setUploadPop(false)} />
                                            </div>
                                            <div className="px-6 pb-5 flex flex-col gap-2">
                                                <label
                                                    onDrop={e => handleImageDrop(e)}
                                                    onDragOver={e => e.preventDefault()}
                                                    className="flex h-[160px] justify-center cursor-pointer flex-col items-center border border-gray5 border-dashed rounded-xl"
                                                >
                                                    <UploadImage className="w-[72px] h-[72px] mb-2" />
                                                    <p className="text-gray2 text-sm">이미지 업로드</p>
                                                    <p className="text-gray3 text-sm">(이미지를 드래그하거나 복사, 붙여넣기하여 등록)</p>
                                                    <input
                                                        accept="image/*"
                                                        type="file"
                                                        className="hidden"
                                                        multiple
                                                        onChange={event => handleImageUpload(event)}
                                                    />
                                                </label>
                                                <div className="flex gap-1">
                                                    {tempFileImages.map((image, index) => (
                                                        <div
                                                            key={index}
                                                            className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden"
                                                        >
                                                            <img
                                                                alt="image"
                                                                src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                                className="w-full h-full object-contain"
                                                            />
                                                            <button
                                                                className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                                onClick={() => handleRemoveImage(index, true)}
                                                            >
                                                                <CloseIcon />
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                                <Button size="L" status="regist" className="w-full" onClick={() => handleConfirmImages()}>
                                                    이미지 등록
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                    <textarea
                                        className="px-3 h-auto py-[7px] placeholder:text-grayicon focus:border-primary1 outline-0 rounded-lg w-full text-sm border border-gray4 resize-none overflow-hidden"
                                        placeholder="직접 입력"
                                        value={orderData.file_memo}
                                        onChange={e => handleChange("file_memo", e.target.value)}
                                        onInput={e => {
                                            e.currentTarget.style.height = "auto";
                                            e.currentTarget.style.height = `${e.currentTarget.scrollHeight}px`;
                                        }}
                                        rows={1}
                                        style={{ minHeight: "8px" }}
                                    />
                                </div>
                            </div>

                        
                        </div>
                    )}
                </div>
            </div>
            <div className="sticky bottom-0 bg-white px-6 py-4 flex gap-2 z-10">
                <Button className="w-full" size="L">
                    취소
                </Button>
                <Button status="regist" className="w-full" size="L" onClick={handleSubmit}>
                    저장
                </Button>
            </div>
            {previewImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
                    onClick={() => setPreviewImage(null)}
                >
                    <div className="w-[920px] bg-white rounded-2xl shadow-custom">
                        <div className="flex items-center justify-between px-6 py-5">
                            <p className="text-2xl font-bold">이미지 크게 보기</p>
                            <CloseBlackIcon className="cursor-pointer" onClick={() => setPreviewImage(null)} />
                        </div>
                        <div className="flex p-5  items-center justify-center ">
                            <img src={previewImage} alt="preview" className="object-contain max-h-[500px]" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewOrder;
